import { withQuery } from './lib/withQuery'

export const getUserUrl = () => 'me'

export const deleteUserUrl = () => 'me'

export const getProfileUrl = () => 'profile'

export const updateProfileUrl = () => 'profile'

export const updateUserUrl = () => 'me'

export const checkUserUrl = (username: string) => withQuery('username', { username })

export const usernameChangedUrl = (username: string) => withQuery('username/changed', { username })

export const verifyEmailUrl = () => 'me/verify'

export const getWebsiteSettingsUrl = () => 'user/website-settings'

export const updateWebsiteSettingsUrl = () => 'user/website-settings'
